import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import LocalBusinessSchema from "@/components/StructuredData";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import ProjectsPage from "@/pages/ProjectsPage";
import ContactPage from "@/pages/ContactPage";
import ForArchitectsPage from "@/pages/ForArchitectsPage";
import ForDevelopersPage from "@/pages/ForDevelopersPage";
import PartnerPage from "@/pages/PartnerPage";
import EstimatorPage from "@/pages/EstimatorPage";
import ResultsPage from "@/pages/ResultsPage";
import QuoteRequestPage from "@/pages/QuoteRequestPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <div className="App min-h-screen bg-stone-50">
          <LocalBusinessSchema />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/projects" element={<ProjectsPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/for-architects" element={<ForArchitectsPage />} />
              <Route path="/for-developers" element={<ForDevelopersPage />} />
              <Route path="/partners/:slug" element={<PartnerPage />} />
              <Route path="/estimator/:projectType" element={<EstimatorPage />} />
              <Route path="/results" element={<ResultsPage />} />
              <Route path="/request-quote" element={<QuoteRequestPage />} />
              <Route path="/admin" element={<AdminLoginPage />} />
              <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" />
        </div>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
